/**
 * @file Handles Firebase initialization and service exports.
 */

// Firebase App Initialization
import { initializeApp } from "https://www.gstatic.com/firebasejs/12.19.0/firebase-app.js";
// Auth Service & Persistence
import { getAuth } from "https://www.gstatic.com/firebasejs/12.19.0/firebase-auth.js";
// Other Services
import { getFirestore } from "https://www.gstatic.com/firebasejs/12.19.0/firebase-firestore.js";
import { getStorage } from "https://www.gstatic.com/firebasejs/12.19.0/firebase-storage.js";
import { initializeAppCheck, ReCaptchaV3Provider } from "https://www.gstatic.com/firebasejs/12.19.0/firebase-app-check.js";

const envConfig = window.__DFC_ENV_CONFIG__;
if (!envConfig?.firebase) {
    throw new Error("Firebase initialized before config/env bootstrap completed.");
}

const hostname = window.location.hostname;
const firebaseConfig = {
    ...envConfig.firebase,
    authDomain: (hostname === "localhost" || hostname === "127.0.0.1") ?
        envConfig.firebase.authDomain :
        window.location.host,
};

/**
 * The core Firebase app instance.
 * @type {FirebaseApp}
 */
export const app = initializeApp(firebaseConfig);

/**
 * The Firebase Authentication service instance.
 * @type {Auth}
 */
export const auth = getAuth(app);

/**
 * The Firebase Firestore service instance.
 * @type {Firestore}
 */
export const db = getFirestore(app);

/**
 * The Firebase Storage service instance.
 * @type {FirebaseStorage}
 */
export const storage = getStorage(app);

// --- App Check Initialization ---
try {
    if (hostname === "localhost" || hostname === "127.0.0.1") {
        const fixedDebugToken = envConfig?.testing?.fixedDebugToken;
        if (fixedDebugToken) {
            self.FIREBASE_APPCHECK_DEBUG_TOKEN = fixedDebugToken;
            console.log("App Check: Using FIXED Dev token from config/env.");
        } else {
            self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
            console.log("App Check: Using generated Dev token.");
        }
    }

    /**
     * The Firebase App Check service instance.
     * @type {AppCheck}
     */
    initializeAppCheck(app, {
        provider: new ReCaptchaV3Provider(envConfig.appCheck.siteKey),
        isTokenAutoRefreshEnabled: true,
    });

} catch (e) {
    console.error("Error initializing App Check", e);
}
